import React, { useEffect, useState } from "react";
import { Cookies } from '../../../../index.js';
import { alert_error, alert_success } from '../../../../AppContext';
import axios from 'axios';
import { Helmet } from "react-helmet";
import Mode_zalo_mem from '../mode_social/mode_zalo_mem.jsx';
import Mode_videos_ffmpeg from '../mode_traffix/mode_videos_ffmpeg.jsx';
import Mode_reports from './mode_reports.jsx';
import Mode_ptc_ads from './mode_ptc_ads.jsx';
import Mode_web_search from './mode_web_search_v2.jsx';
import Mode_videos_instruct from './mode_videos_instruct_1.jsx';
import { RingLoader, BarLoader } from "react-spinners";
import Buylink from './../../urlshorten_system/buy_link.jsx';
import Login_google from './.././../login';
import Post_content from '../../../../community/content/Blog_posts.jsx';
import { useSelector, useDispatch } from 'react-redux';
import { update_media_link_tik, update_tiktok_users_id } from '../../../../order/orders/actions.js';

const AboutUs = (props) => {
    const dispatch = useDispatch();
    const money = props.money;
    const [nutxuly, setnutxuly] = useState(0);
    const [nutorder, setnutorder] = useState('Bước 4: Ấn xác nhận');
    const [data_ok, setdata_ok] = useState(null);
    const [apikey, setapikey] = useState(false);
    const [datajoptiktok, setDatajoptiktok] = useState('');
    const [hustmediavipro, sethustmediavipro] = useState("");
    const media_link_tik = useSelector(state => state.media_link_tik);
    const tiktok_users_id = useSelector(state => state.tiktok_users_id);
    const comments_orders = useSelector(state => state.comments_orders);
    const media_link_tik_cookie = Cookies.get('media_link_tik');
    const tiktok_users_id_cookie = Cookies.get('tiktok_users_id');

    const set_media_link_tik = (value) => {
        dispatch(update_media_link_tik(value));
        Cookies.set('media_link_tik', value, { expires: 300 });
    };
    const set_tiktok_users_id = (value) => {
        dispatch(update_tiktok_users_id(value));
        Cookies.set('tiktok_users_id', value, { expires: 300 });
    };
    useEffect(() => {
        if (media_link_tik_cookie) {
            set_media_link_tik(media_link_tik_cookie);
        }
        if (tiktok_users_id_cookie) {
            set_tiktok_users_id(tiktok_users_id_cookie);
        }
    }, []);

    useEffect(() => {
        sadasdasdasdasd();
        const hustmediavipro = Cookies.get("hustmediavipro");
        sethustmediavipro(hustmediavipro);
        const myCookieValue = Cookies.get("apikey");
        setapikey(myCookieValue);
    }, []);
    function sadasdasdasdasd() {
        const myCookieValue = Cookies.get("apikey");
        const code_item = Cookies.get("code_item");
        const hustmediavipro = Cookies.get("hustmediavipro");
        axios.get('https://hust.media/link/load_mode/mode_image_check_start.php', {
            params: {
                lienket: hustmediavipro,
                apikey: myCookieValue,
                code_item: code_item
            },
        })
            .then(response => {
                console.log(response.data);
                if (response.data.status != 1 && response.data.message != '') {
                    alert_error(response.data.message);
                    //   chuyenhuong(response.data);
                }
                else if (response.data.status == 1) {
                    setDatajoptiktok(response.data.datajop[0]);
                    setdata_ok(response.data.datajop);
                    console.log(response.data.datajop[0]);
                    if (response.data.datajop[0].magiaodich) {
                        // setLinkweb(response.data.datajop[0].lienketjop);
                        alert_success('Lấy dữ liệu jop thành công');
                        console.log(response.data.datajop);
                    }
                }
                else {
                    alert_error('Đã xảy ra lỗi máy chủ vui lòng liên hệ admin');
                }
                // testFunction(response);
            })
            .catch(error => {
                console.error(error);
            });
    };

    function handleSubmit(event) {
        const upload_videos_check = Cookies.get("upload_videos_check");

        setnutxuly(1);
        const apikey = Cookies.get('apikey');
        event.preventDefault();
        setnutorder('Please wait a moment 😊');
        const mediaArray = media_link_tik
            .split('\n')                // tách theo dòng
            .map(line => line.replace(/\s+/g, '')) // bỏ tất cả khoảng trắng trong dòng
            .filter(line => line !== ''); // loại bỏ dòng rỗng

        if ((!media_link_tik || !tiktok_users_id) && datajoptiktok.category.includes('tik_cmts_ref')) {
            console.log(mediaArray);
            alert_error('Chưa nhập id và liên kết video')
            setnutxuly(0);
            setnutorder('điền đủ thông tin');
            return
        }

        if (!upload_videos_check || upload_videos_check == 'false') {
            console.log(upload_videos_check);
            alert_error('Chưa tải videos lên')
            setnutxuly(0);
            setnutorder('điền đủ thông tin');
            return
        }
        if (!comments_orders && datajoptiktok?.category?.includes('p2p_mmo')) {
            console.log(comments_orders);
            alert_error('Chưa nhập ghi chú')
            setnutxuly(0);
            setnutorder('điền đủ thông tin');
            return
        }

        const code_item = Cookies.get("code_item");
        const hustmediavipro = Cookies.get("hustmediavipro");
        const url = 'https://hust.media/link/load_mode/mode_image_check_end.php';
        let data = JSON.stringify({
            "apikey": apikey,
            "code_item": code_item,
            "lienket": hustmediavipro,
            "id_jop": datajoptiktok.id,
            "magiaodich": datajoptiktok.magiaodich,
            "media_link_tik": mediaArray,
            "tiktok_users_id": tiktok_users_id,
            "comments_orders": comments_orders
        });
        axios.post(url, data)
            .then(
                response => (testFunction(response))
            )
            .catch(error => errorapi(error))
    };
    function errorapi(error) {
        alert_error(error);
        setnutxuly(0);
    };
    function testFunction(response) {
        setnutxuly(0);
        const info = response.data;
        const status = info.status;
        const message = info.message;
        setnutorder('đặt tiếp luôn nào')
        if (status == 0) {
            alert_error(info.message);
        }
        else if (status == 1) {
            set_media_link_tik('');
            alert_success(info.message);
        }
        if (info.redirect != null && info.redirect != '') {
            Cookies.set('upload_videos_check', false, { expires: 300 });
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                window.location.href = info.redirect;
            }, 1700);
        }
    };
    return (
        <div className=" justify-center items-center mt-1">
            {/* <Helmet>
                <title>Hướng dẫn vượt link Hust Media</title>
            </Helmet> */}
            {apikey ? (<><Buylink money={money} hustmediavipro={hustmediavipro} /></>) : (<>
                <div className="mb-1 ">
                    <div>Đăng nhập google để nhận link miễn phí</div>
                    <Login_google />
                </div>
                <div className="mb-1 ">Hoặc:</div>
            </>)}
            <div className="justify-center items-center flex">
                <div className="max-w-2xl bg-white shadow-lg rounded-lg overflow-hidden">
                    <div className="px-1 py-3">
                        <div className="font-bold text-base mb-1">Hướng dẫn xem link Hust Media</div>
                        <Mode_videos_ffmpeg />
                        <button disabled={nutxuly == 1} onClick={handleSubmit}
                            className='mt-2 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-2 w-full dark:bg-slate-800 dark:text-white'>
                            <div className='flex items-center justify-between flex-1'>
                                {nutxuly == 1 &&
                                    <div className="spinner-border" role="status">

                                    </div>}


                                <span className='text-lg font-medium text-white'>
                                    {nutorder} </span>
                                <div className="text-xl">
                                    {'\u27A4'}
                                </div>
                            </div>
                        </button>

                        <div className="mb-1">

                            <h2 className="text-lg font-bold mb-0">Đọc kỹ mới làm</h2>
                            {datajoptiktok.api_categorymini}
                            {
                                datajoptiktok ? (<>
                                    {
                                        (datajoptiktok.api_categorymini?.includes('videos_check')
                                            || datajoptiktok.api_categorymini?.includes('p2p_mmo')) &&
                                        (
                                            <>
                                                <div className="text-center">
                                                    < Mode_videos_instruct datajoptiktok={datajoptiktok} />
                                                </div>
                                            </>
                                        )
                                    }
                                    {
                                        datajoptiktok.category.includes('tik_cmts_ref') &&
                                        (
                                            <>
                                                <div className="text-center">
                                                    <>
                                                        <label className="block">
                                                            <span className="text-lg font-bold mb-0">Nhập id tiktok</span>
                                                            <input
                                                                type="text"
                                                                value={tiktok_users_id}
                                                                onChange={(e) => set_tiktok_users_id(e.target.value)}
                                                                placeholder="Ví dụ: hustmedia"
                                                                className="mt-1 block w-full rounded-lg border border-gray-300 px-3 py-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-300"
                                                            />
                                                        </label>
                                                        <div className="mb-1">
                                                            <h3 className="text-lg font-bold mb-0">Nhập lists link videos bạn đã cmts</h3>
                                                            <label className="block">
                                                                <textarea
                                                                    value={media_link_tik}
                                                                    onChange={(e) => set_media_link_tik(e.target.value)}
                                                                    placeholder="Nhập liên kết video mỗi cái 1 dòng..."
                                                                    className="mt-1 block w-full rounded-lg border border-gray-300 px-4 py-3 text-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-300 resize-none"
                                                                    rows={5}
                                                                ></textarea>
                                                            </label>
                                                        </div>
                                                    </>
                                                </div>
                                            </>
                                        )
                                    }
                                    {
                                        datajoptiktok.category.includes('web_search') &&
                                        (
                                            <>
                                                < Mode_videos_instruct datajoptiktok={datajoptiktok} />
                                            </>
                                        )
                                    }
                                </>) : (
                                    <div className="mt-2 flex justify-center items-center">
                                        <BarLoader size={50} color="#003AA5" />{" "}
                                    </div>
                                )}
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
}

export default AboutUs;
